import React from 'react';
import styles from './ButtonLoader.scss';
import Loader from '../Loader';
import { bool } from 'prop-types';
import classNames from 'classnames';
import Check from 'wix-ui-icons-common/Check';
import { Button } from 'wix-style-react';

export default function ButtonLoader({ isLoading, isSuccessful, children, ...rest }) {
  const calcLoaderSize = () => {
    return rest.size === 'tiny' || rest.size === 'small' ? 15 : Loader.defaultProps.size;
  };

  return (
    <Button {...rest}>
      <span
        className={classNames([styles.wrapper, isLoading && styles.isLoading, isSuccessful && styles.isSuccessful])}
      >
        <span className={styles.contentWrapper}>{children}</span>
        <div className={styles.loaderWrapper}>
          <Loader size={calcLoaderSize()} className={styles.loader} data-hook="button-loader-loading" />
        </div>
        <div className={styles.successfulWrapper}>
          <Check />
        </div>
      </span>
    </Button>
  );
}

ButtonLoader.displayName = 'ButtonLoader';
ButtonLoader.propTypes = {
  isLoading: bool,
  isSuccessful: bool,
};
